/* eslint-disable */
import React, { useMemo, useEffect, useRef } from "react";
import ReactMarkdown from "react-markdown";
import { processNewLines } from "../utils/text-field-utils";
import fieldPropTypes from "./field-prop-types";
import { fieldValidation } from "../utils/field-validation";
import {
  getFieldActionEventStates,
  actionEventsMap
} from "../screens/helpers/action-event-states";

const handleTextClickWrapper = (
  event,
  field,
  appData,
  onClickEventStates = []
) => {
  event.stopPropagation();
  appData.handleButtonClick(
    field.name,
    field.text,
    field.action,
    0,
    undefined,
    onClickEventStates
  );
};

const TextWithValidation = ({
  field,
  appData,
  Text: TextView,
  HtmlText,
  Link: LinkView,
  ariaLabel = "",
  props
}) => {
  if (field?.layout?.visible === false) {
    return null;
  }
  const fieldRef = useRef();
  useEffect(() => {
    if (field?.data?.groupName) {
      fieldValidation[field.type].update(field, appData, { fieldRef });
    }
  }, [appData.screenValidation, field]);

  const onClickEventStates = useMemo(
    () => getFieldActionEventStates(field, actionEventsMap.onClick),
    [field, field?.data?.updatedActionEventStates]
  );

  const image = !appData?.properLink ? field?.image : "";

  return field.action || onClickEventStates?.length ? (
    field.action?.type !== "bold" ? (
      appData.properLink ? (
        <LinkView
          name={field.name}
          label={processNewLines(field)}
          onClick={event => handleTextClickWrapper(event, field, appData)}
          params={field.params}
          className={`linkComponent ${
            field?.action?.targetBlank ? "external-link" : ""
          }`}
          ariaLabel={ariaLabel}
          targetBlank={field?.action?.target_blank}
          accessibility={field.accessibility}
          data={field.data}
        />
      ) : (
        <TextView
          name={field.name}
          label={processNewLines(field)}
          onClick={event =>
            handleTextClickWrapper(event, field, appData, onClickEventStates)
          }
          params={field.params}
          updatedTextColor={field.updatedTextColor}
          layout={field.layout}
          fieldRef={fieldRef}
          updatedLayout={field.updatedLayout}
          data={field.data}
        />
      )
    ) : (
      <HtmlText
        value={field.action.value}
        params={field.params}
        name={field.name}
      />
    )
  ) : (
    <TextView
      image={image}
      accessibility={field.accessibility}
      name={field.name}
      label={processNewLines(field)}
      params={field.params}
      updatedTextColor={
        field.updatedTextColor || { color: field?.data?.websdkTextColor }
      }
      layout={field.layout}
      fieldRef={fieldRef}
      ariaLive={field?.accessibility?.role === "alert"}
      isStatus={field?.accessibility?.role === "status"}
      data={field.data}
      {...props}
    />
  );
};

// eslint-disable-next-line no-shadow
const Text = ({
  field,
  appData,
  components: { Text, HtmlText, Link },
  ...props
}) => {
  if (field.params && field.params.includes("TDFieldOptionHTML")) {
    return (
      <HtmlText
        value={field.text || field.title}
        params={field.params}
        name={field.name}
      />
    );
  } else if (field.params && field.params.includes("TDFieldOptionMarkdown")) {
    return <ReactMarkdown>{field.title}</ReactMarkdown>;
  }

  return (
    <TextWithValidation
      field={field}
      appData={appData}
      Text={Text}
      Link={Link}
      HtmlText={HtmlText}
      props={props}
    />
  );
};

Text.propTypes = fieldPropTypes;

TextWithValidation.propTypes = fieldPropTypes;

export default Text;
